// extracted by mini-css-extract-plugin
module.exports = {"content":"PageContent-content-38ErY"};